import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import GuestLayout from '../components/GuestLayout';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SectionDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [section, setSection] = useState(null);

  useEffect(() => {
    axios.get(`${API}/sections/${id}`).then(res => setSection(res.data)).catch(console.error);
  }, [id]);

  if (!section) return (
    <GuestLayout>
      <div className="flex items-center justify-center h-64">
        <div className="w-6 h-6 border-2 border-espresso border-t-transparent rounded-full animate-spin" />
      </div>
    </GuestLayout>
  );

  return (
    <GuestLayout>
      <div className="max-w-md mx-auto md:max-w-2xl">
        {/* Hero Image */}
        {section.image_url && (
          <div className="relative aspect-[16/10] overflow-hidden">
            <img src={section.image_url} alt={section.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-espresso/50 via-transparent to-espresso/20" />
            <button
              data-testid="section-back-btn"
              onClick={() => navigate(-1)}
              className="absolute top-5 left-5 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center"
            >
              <ArrowLeft size={18} className="text-espresso" />
            </button>
            <div className="absolute bottom-5 left-6 right-6">
              <h1 data-testid="section-title" className="font-heading text-2xl text-white">{section.title}</h1>
            </div>
          </div>
        )}

        {/* Content */}
        <div className="px-6 py-6">
          {!section.image_url && (
            <div className="flex items-center gap-3 mb-6">
              <button data-testid="section-back-btn-alt" onClick={() => navigate(-1)} className="text-espresso">
                <ArrowLeft size={20} />
              </button>
              <h1 className="font-heading text-2xl text-espresso">{section.title}</h1>
            </div>
          )}

          <p className="text-text-muted mb-6 leading-relaxed">{section.description}</p>

          {section.content && (
            <div
              className="section-content"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          )}

          {/* Video embed */}
          {section.video_url && (
            <div className="mt-6 rounded-2xl overflow-hidden aspect-video">
              <iframe
                src={section.video_url}
                title={section.title}
                className="w-full h-full"
                allowFullScreen
              />
            </div>
          )}

          {/* Additional Images */}
          {section.images?.length > 1 && (
            <div className="mt-6 space-y-3">
              {section.images.slice(1).map((img, i) => (
                <img key={i} src={img} alt="" className="w-full rounded-2xl" />
              ))}
            </div>
          )}
        </div>
      </div>
    </GuestLayout>
  );
}
